import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemLexorankRoute: InvariantJiraRoute = {
	name: 'global-settings-system-lexorank',
	path: '/secure/GHLexoRankManage.jspa',
	query: ['decorator=admin'],
};
